import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/notification_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  kind_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'Notification',
      options: ['pick_customer', 'release_customer', 'assign_customer', 'pool_assign_customer', 'apply_assign_customer', 'cancel_apply_assign_customer', 'approve_assign_customer', 'reject_assign_customer', 'fill_customer_info_remind', 'follow_customer_remind', 'memo_remind', 'follow_customers_remind', 'update_approved_payment', 'cancel_finished_sales_order', 'payment_remind', 'customer_pool_opening', 'customer_claim_followup_due', 'customer_capacity_warning', 'customer_claim_timeout_returned', 'customer_release_warning'],
    },
    model_name: 'Notification',
    column_name: 'kind',
  },
  read_at_null: {
    column_type: 'datetime',
    model_name: 'Notification',
    column_name: 'readAt',
  },
  target_of_Customer_type_id_eq: {
    model_name: 'Customer',
    column_type: 'string',
    column_name: 'id',
  },
  target_of_Customer_type_customer_level_id_eq: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  customer_level: {
    column_type: 'belongs_to',
    column_name: 'customer_level',
    extra: {
      model_name: 'CustomerLevel',
      value_column: 'id',
    },
    model_name: 'Customer',
  },
  actor_of_User_type_id_eq: {
    model_name: 'User',
    column_type: 'string',
    column_name: 'id',
  },
  created_at_gteq_date: {
    column_type: 'datetime',
    model_name: 'Notification',
    column_name: 'createdAt',
  },
  created_at_lteq_date: {
    column_type: 'datetime',
    model_name: 'Notification',
    column_name: 'createdAt',
  },
}
export const formColumnsConfig = {
 'self': {}
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('Notification', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('Notification', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
